<template>
    <link-document-markdown class="link-document-item-text" :value="data.text"/>
</template>

<script>

    export default {
        name: "link-document-item-text",
        props: ['data']
    }
</script>

<style lang="scss">

</style>
